import { CouponNumberGroupConfig } from '@/config/game';
import { CouponGroupState } from '@/reducers/couponGroup';

export function countFilledCoupons(
  coupons: CouponGroupState,
  groupConfig: CouponNumberGroupConfig[]
): number {
  let counter = 0;
  Object.keys(coupons).forEach((coupon) => {
    const crossedNumbers = coupons[coupon];
    if (
      groupConfig.every(
        (group, i) => crossedNumbers[i].length >= group.minCrossed
      )
    ) {
      counter++;
    }
  });
  return counter;
}
